import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { alpha, makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import EpwtLogo from '../../img/companies/epwt-logo.webp';

const logoStyle = {
    maxWidth: "350px",
    display: "block",
    margin: "2rem"
}
export default function Header() {

    return (
        <>
            <div>
                <img src={EpwtLogo} style={logoStyle} className="epwt-logo" />
            </div>
        </>
    );
}
